<!--仓库管理 -  盘库-->
<template>
  <div>
    <div id="historystock">
      <el-row style="margin:0">
        <el-form :inline="true" class="demo-form-inline" :model="form" :ref="form" style="margin: 0">
          <el-col :xl="5" :lg="12" :md="12">
            <el-form-item label="开始时间：">
              <el-date-picker size="medium" v-model="form.START_MONTH" value-format="yyyy-MM-dd" placeholder="选择日期时间" style="width: 200px">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xl="5" :lg="12" :md="12">
            <el-form-item label="结束时间：">
              <el-date-picker size="medium" v-model="form.END_MONTH" value-format="yyyy-MM-dd" placeholder="选择日期时间" style="width: 200px">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xl="5" :lg="8" :md="12">
            <el-form-item label="状态：">
              <label slot="label">状&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;态：</label>
              <el-select size="medium" filterable v-model="form.STATUS" placeholder="请选择" clearable>
                <el-option v-for="item in STATUS_LIST" :key="item.status" :label="item.name" :value="item.status">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="{ span: 1, offset: 1 }" :lg="1" :md="1">
            <el-button size="medium" type="primary" @click="filtrate()" :loading="loading">筛选</el-button>
          </el-col>
          <el-col :xl="{ span: 2, offset: 5 }" :lg="{ span: 2, offset: 2 }" :md="{ span: 2, offset: 5 }">
            <el-button size="medium" @click="addPK()" v-show="fun_dic[105030101]">创建盘库单</el-button>
          </el-col>
        </el-form>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" stripe border style="width: 100%">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="ENTRY_DATE" label="盘库日期" min-width="100"></el-table-column>
            <el-table-column prop="PK_CODE" label="盘库编号" min-width="180"></el-table-column>
            <el-table-column prop="BEFORE_WORTH" label="盘前金额" min-width="100"></el-table-column>
            <el-table-column prop="AFTER_WORTH" label="盘后金额" min-width="100"></el-table-column>
            <el-table-column label="盘赢/盘亏">
              <template slot-scope="scope">
                <span :style="$_setFontColor(scope.row.PK_VALUE)">
                  {{ scope.row.PK_VALUE }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.STATUS == 1" type="warning">盘库中</el-tag>
                <el-tag v-if="scope.row.STATUS == 2" type="success">盘库完成</el-tag>
                <el-tag v-if="scope.row.STATUS == 101" type="warning">盘库审核中</el-tag>
                <el-tag v-if="scope.row.STATUS == 202" type="danger">审核未通过</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="250">
              <template slot-scope="scope">
                <div class="btns">
                  <el-button type="text" icon="el-icon-view" size="small" v-if="scope.row.STATUS === 2 || scope.row.STATUS === 3"
                    @click="detail(scope.row)">查看</el-button>
                  <el-button type="text" v-if="scope.row.STATUS === 1" icon="el-icon-view" size="small" @click="entryData(scope.row)">录入数据</el-button>
                  <el-button type="text" v-if="scope.row.STATUS === 202" icon="el-icon-view" size="small"
                    @click="reEntry(scope.row)">重新录入数据</el-button>
                  <el-button type="text" v-if="scope.row.STATUS === 1" icon="el-icon-close" @click="delThisEntry(scope.row)"
                    size="small">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!--分页-->
      <div class="pagination_box" v-show="total_count > 10">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="total_count"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {
  setFontColor, profitFun, delEntry,
} from 'api/warehouseManager';
import { getActionFun } from 'api/login';

export default {
  data() {
    return {
      form: {
        STATUS: 0,
      },
      loading: false,
      tableData: [],
      total_count: 0,
      currentPage: 1,
      pageSize: 20,
      // 是否禁用创建盘库单按钮
      // isDisabled: false,
      PAGE_ID: '1050301', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 105030101: 0 },
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.INVENTORY_SEARCH.CONDITION) {
      this.form = this.INVENTORY_SEARCH.CONDITION;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
    this.queryBeforeFun();
  },
  computed: {
    STATUS_LIST() {
      return [
        { status: 0, name: '全部' },
        { status: 1, name: '盘库中' },
        { status: 2, name: '盘库完成' },
        { status: 101, name: '盘库审核中' },
        { status: 202, name: '审核未通过' }];
    },
    // 当前的日期
    CURRENT_DATE() {
      return this.$store.state.CURRENT_DATE;
    },
    INVENTORY_SEARCH() {
      return this.$store.state.INVENTORY_SEARCH;
    },
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // ------------------拉取数据
    queryData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      profitFun(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].list;
          this.total_count = result[0].TOTAL_COUNT;
        } else {
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
        // this.isDisabled = this.setDisabledValue(this.tableData)
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ---------------------------------筛选
    filtrate() {
      const data = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      for (const key in this.form) {
        if (this.form[key] !== undefined && this.form[key] !== null) {
          if (key === 'STATUS') {
            this.form[key] = Number(this.form[key]);
          }
          data[key] = this.form[key];
        }
      }
      if (JSON.stringify(data) !== '{}') {
        this.loading = true;
        profitFun(data).then((result) => {
          if (result[0]) {
            this.tableData = result[0].list;
            this.total_count = result[0].TOTAL_COUNT;
            this.$message.show({ text: '查询成功', type: 'success' });
          } else {
            this.tableData = [];
            this.total_count = 0;
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
          this.loading = false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.loading = false;
        });
      } else {
        this.$message.show({ text: '无筛选条件', type: 'warning' });
      }
      this.$store.dispatch('SET_INVENTORY_SEARCH', {
        CONDITION: this.form,
      });
    },
    detail(row) {
      this.$router.push({ path: '/stockDetail/detail' });
      sessionStorage.setItem('pk_id', row.ID);
      sessionStorage.setItem('pk_code', row.PK_CODE);
      sessionStorage.setItem('gysName', row.GYS_NAME);
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    // -----------------------------------设置盘盈盘亏颜色显示
    $_setFontColor(number) {
      return setFontColor(Number(number));
    },
    // --------------------------
    addPK() {
      this.$confirm('盘库前请确认所有订单已验收且入库，开始盘库，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$router.push({ path: '/createStock' });
      }).catch(() => { });
    },
    // ------------------------------------录入数据
    entryData(row) {
      this.$store.commit('SET_PK_ID', row.ID);
      this.$router.push({ path: '/createStock' });
    },
    // -------------------------------------------------------------删除数据
    delThisEntry(row) {
      this.$confirm('是否永久删除此条盘库记录, 是否继续?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          PK_ID: row.ID,
        };
        delEntry(params).then((res) => {
          this.$message.show({ text: '删除成功', type: 'success' });
          this.tableData.splice(row.$index, 1);
          // this.isDisabled = this.setDisabledValue(this.tableData)
          this.queryData();
        }).catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
        this.queryData();
      }).catch(() => {
        this.$message.show({ text: '已取消删除', type: 'info' });
      });
    },
    reEntry(row) {
      this.$router.push({ path: `/entryStock/${row.STATUS}`, params: { status: row.STATUS } });
      sessionStorage.setItem('pk_id', row.ID);
      sessionStorage.setItem('pk_code', row.PK_CODE);
      sessionStorage.setItem('reason', row.COMMENT);
    },
  },
};
</script>
<style scoped>
.pagination_box {
  float: right;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/checkStock.vue